// removed by extract-text-webpack-plugin
module.exports = {"header":"header__3fP58","restart":"restart__2MlxQ","logo":"logo__isHcN","logo_weldshop":"logo_weldshop__31Yyg"};


//////////////////
// WEBPACK FOOTER
// ./components/header/style.less
// module id = V3m6
// module chunks = 6